import { createSelector } from 'reselect';

import { setDefaultSource, getCountries } from '../helpers/costcenter';

const getCountryFilterSelector = state => state.auth.config.filters;

//get filtered countries selectors
export const getFilterCountries = createSelector(
  getCountryFilterSelector,
  getCountries
);

const getCommonCostCenterSelector = state =>
  state.common ? state.common.costcenter : {};

const getCommonCountrySelector = state =>
  state.common ? state.common.country : {};

const getCompCodeandCostCenter = (costcenter, country, countries) => {
  return setDefaultSource(country, costcenter, countries);
};

export const getGLBCCandCostCenter = createSelector(
  getCommonCostCenterSelector,
  getCommonCountrySelector,
  getFilterCountries,
  getCompCodeandCostCenter
);



// WEBPACK FOOTER //
// ./src/utils/globalSelectors/index.js